// services/agingReport.service.ts

import { AgingFilter } from "../types/aging.types";
import agingReportApi from "../api/agingReport.api";

const AgingReportService = {
  /**
   * 📊 Resumen superior
   * GET /api/payables/aging/summary
   */
  getSummary: async () => {
    const response =
      await agingReportApi.fetchCustom(
        "/summary"
      );

    return response.data;
  },

  /**
   * 📄 Tabla paginada
   * POST /api/payables/aging/table?page=0&size=10&sort=SupplierName,asc
   */
  getTable: async (
    filters: AgingFilter,
    page = 0,
    size = 10,
    sort = "SupplierName,asc"
  ) => {
    const response =
      await agingReportApi.addCustom(
        `/table?page=${page}&size=${size}&sort=${sort}`,
        filters
      );

    return response.data;
  },
};

export default AgingReportService;